<div class="header">
    <h2 mat-dialog-title>{{ 'locker.consumption.title' | translate }}</h2>
    <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
</div>

@if (lockerSpirit) {
    <mat-dialog-content>
        <form [formGroup]="form">
            <div class="form-row">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'locker.consumption.quantity' | translate }}</mat-label>
                    <input matInput formControlName="quantity" type="number" min="1" max="lockerSpirit.quantity">
                </mat-form-field>
                @if (form.get('quantity')?.touched && form.get('quantity')?.invalid) {
                    <mat-error>{{ 'locker.consumption.quantity_error' | translate }}</mat-error>
                }
            </div>
            <div class="form-row">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'locker.consumption.status' | translate }}</mat-label>
                    <mat-select formControlName="status">
                        <mat-option [value]="statusOptions.partial">{{ 'locker.consumption.status_partial' | translate }}</mat-option>
                        <mat-option [value]="statusOptions.finished">{{ 'locker.consumption.status_finished' | translate }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            @if (form.get('status')?.value == statusOptions.partial) {
                <div class="form-row">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'locker.consumption.remaining_quantity' | translate }}</mat-label>
                        <input matInput formControlName="remainingQuantity" type="number" min="0" max="100" step="1">
                        <span matPrefix>%</span>
                    </mat-form-field>
                </div>
            }
            <div class="form-row">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'locker.detail.notes' | translate }}</mat-label>
                    <textarea matInput formControlName="notes"></textarea>
                </mat-form-field>
            </div>
        </form>
    </mat-dialog-content>
}

<mat-dialog-actions align="end">
    <button mat-button class="btn-white" type="button" (click)="close()">{{ 'locker.consumption.close' | translate }}</button>
    <button mat-flat-button color="primary" (click)="saveConsumption()">{{ 'locker.consumption.save' | translate }}</button>
</mat-dialog-actions>